export const formatNumberShort = (
  value: number,
  decimalSeparator = '.',
  maxDecimals = 2,
) =>
  (value >= 1000000
    ? `${(value / 1000000).toFixed(maxDecimals).replace(/\.?0+$/, '')}m`
    : value >= 1000
      ? `${(value / 1000).toFixed(maxDecimals).replace(/\.?0+$/, '')}k`
      : value.toFixed(maxDecimals).replace(/\.?0+$/, '')
  ).replace('.', decimalSeparator);
